export const getIdFromHash = <N extends boolean>(
	hash: string,
	regex: RegExp,
	isNumber: N,
): N extends true ? number | undefined : string | undefined => {
	const match = hash.match(regex);
	if (!match) return undefined;
	if (isNumber) {
		const id = parseInt(match[1]);
		return !isNaN(id) ? (id as N extends true ? number : never) : undefined;
	}
	return match[1] as N extends true ? never : string;
};
